import styled from "@emotion/styled";
import React, { useState, useEffect, useCallback } from "react";

import Button from "../../../common/atoms/Button";
import theme from "../../../common/theme";

const ButtonStyled = styled(Button)`
  display: flex;
  gap: 10px;
  align-items: center;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 8px;
  background-color: white;
  color: ${theme.colors.white};

  padding-inline: 15px;
  transform: perspective(1px) translateZ(0);
  transition-duration: 0.3s;
  transition-property: transform;
  &:hover,
  &:active,
  &:focus {
    transform: scale(0.9);
  }
`;

const ShortcutButton = () => {
  const [isInstalled, setIsInstalled] = useState(false);
  const [isCompatibleBrowser, setIsCompatibleBrowser] = useState(false);
  const [hasPrompt, setHasPrompt] = useState(false);

  const handleAddToHomeScreen = async () => {
    const deferredPrompt = window.deferredPrompt;
    
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      
      if (choiceResult.outcome === 'accepted') {
        setHasPrompt(false);
      }
      
      window.deferredPrompt = null;
    }
  };

  useEffect(() => {
    const checkIfInstalled = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const isNavigatorStandalone = window.navigator.standalone === true;
      
      if (isStandalone || isNavigatorStandalone) {
        setIsInstalled(true);
        return true;
      }
      return false;
    };

    const checkBrowserCompatibility = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isChrome = /chrome/.test(userAgent) && !/edg/.test(userAgent);
      const isEdge = /edg/.test(userAgent);
      
      return isChrome || isEdge;
    };

    const handlePwaInstallAvailable = () => {
      setHasPrompt(true);
    };

    const installed = checkIfInstalled();
    const compatible = checkBrowserCompatibility();
    
    setIsCompatibleBrowser(compatible);

    if (!installed && compatible) {
      if (window.deferredPrompt) {
        setHasPrompt(true);
      }
      
      window.addEventListener('pwa-install-available', handlePwaInstallAvailable);
      
      window.addEventListener('appinstalled', () => {
        setIsInstalled(true);
        setHasPrompt(false);
      });
    }

    return () => {
      window.removeEventListener('pwa-install-available', handlePwaInstallAvailable);
    };
  }, []);

  if (isInstalled || !isCompatibleBrowser) {
    return null;
  }

  return (
    <ButtonStyled onClick={handleAddToHomeScreen} size="large">
      <i
        className="bi bi-house-add"
        style={{
          fontSize: "1.5rem",
          color: "#000",
        }}
      />
    </ButtonStyled>
  );
};

export default ShortcutButton;
